class ErrorsRelationBuilder {
  static errorsRelation(objectBuilder) {
    return objectBuilder.object(
      "errors",
      (builder) => builder.field("type").field("message").object(
        "path",
        (builder2) => builder2.inlineFragment("_FieldPathFragment", (builder3) => builder3.field("field")).inlineFragment("_IndexPathFragment", (builder3) => builder3.field("index").field("alias"))
      )
    );
  }
}
export {
  ErrorsRelationBuilder
};
//# sourceMappingURL=ErrorsRelationBuilder.js.map
